import React from 'react';
import { COCKPIT_AUDIT_LOG } from './cockpit-data.jsx';
import { Icon } from './icons.jsx';
// Cockpit: Tab Logs e Auditoria

const SEVERITY_CFG = {
  info:    { label: 'Info',    bg: 'var(--info-bg)',    color: 'var(--info)'    },
  warning: { label: 'Aviso',  bg: 'var(--warning-bg)', color: 'var(--warning)' },
  danger:  { label: 'Crítico', bg: 'var(--danger-bg)',  color: 'var(--danger)'  },
  success: { label: 'OK',     bg: 'var(--success-bg)', color: 'var(--success)' },
};

const RESULT_CFG = {
  success: { label: 'Sucesso', color: 'var(--success)' },
  error:   { label: 'Erro',    color: 'var(--danger)'  },
  warning: { label: 'Aviso',   color: 'var(--warning)' },
};

const ACTION_TYPES = ['Todos', 'Login como lojista', 'Plano alterado', 'Tenant suspenso', 'Token revogado', 'Repair executado', 'Senha resetada', 'Domínio validado', 'Tenant criado'];
const ACTORS_LIST  = ['Todos', 'Sistema', 'Julio Lazzaron', 'Pedro Chaves', 'Beatriz Lima', 'Rafael Tavares', 'Ana Rodrigues'];
const SEVERITIES   = ['Todos', 'info', 'warning', 'danger'];

// ── LogDetailDrawer ───────────────────────────────────────────────────────────
const LogDetailDrawer = ({ log, onClose }) => {
  if (!log) return null;
  return (
    <div className="drawer-overlay" onClick={onClose}>
      <div className="drawer" onClick={e => e.stopPropagation()}>
        <div className="drawer-head">
          <div style={{ flex: 1 }}>
            <h3>Detalhe do evento</h3>
            <div className="sub">{log.ts}</div>
          </div>
          <button className="icon-action" onClick={onClose}><Icon name="x" size={16} /></button>
        </div>
        <div className="drawer-body">
          <div className="drawer-section">
            <h4>Informações gerais</h4>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
              {[
                { label: 'Ação',      value: log.action },
                { label: 'Recurso',   value: log.resource },
                { label: 'Resultado', value: <span style={{ color: RESULT_CFG[log.result]?.color, fontWeight: 600 }}>{RESULT_CFG[log.result]?.label}</span> },
                { label: 'Severidade', value: <span style={{ padding: '2px 8px', borderRadius: 4, background: SEVERITY_CFG[log.severity]?.bg, color: SEVERITY_CFG[log.severity]?.color, fontSize: 11, fontWeight: 600 }}>{SEVERITY_CFG[log.severity]?.label}</span> },
                { label: 'Data/hora', value: <span style={{ fontFamily: 'JetBrains Mono, monospace', fontSize: 12 }}>{log.ts}</span> },
                { label: 'IP',        value: <span style={{ fontFamily: 'JetBrains Mono, monospace', fontSize: 12 }}>{log.ip}</span> },
              ].map((r, i) => (
                <div key={i} style={{ display: 'flex', justifyContent: 'space-between', gap: 16, padding: '8px 0', borderBottom: '1px solid var(--border)', fontSize: 13 }}>
                  <span style={{ color: 'var(--text-muted)', fontWeight: 500 }}>{r.label}</span>
                  <span style={{ color: 'var(--text)', textAlign: 'right' }}>{r.value}</span>
                </div>
              ))}
            </div>
          </div>
          <div className="drawer-section">
            <h4>Ator</h4>
            <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
              <div style={{ width: 36, height: 36, borderRadius: 8, background: 'var(--bg-subtle)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 700, fontSize: 12, color: 'var(--text-secondary)' }}>
                {log.actor === 'Sistema' ? <Icon name="server" size={16} /> : log.actor.split(' ').slice(0, 2).map(w => w[0]).join('')}
              </div>
              <div>
                <div style={{ fontSize: 13, fontWeight: 600 }}>{log.actor}</div>
                <div style={{ fontSize: 11, color: 'var(--text-muted)' }}>{log.orgRole}</div>
              </div>
            </div>
          </div>
          <div className="drawer-section">
            <h4>Motivo registrado</h4>
            <div style={{ fontSize: 13, color: 'var(--text-secondary)', background: 'var(--bg-subtle)', padding: '10px 12px', borderRadius: 7 }}>
              {log.motivo || '—'}
            </div>
          </div>
          <div>
            <h4 style={{ fontSize: 12, fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.06em', color: 'var(--text-muted)', marginBottom: 10 }}>Payload técnico</h4>
            <div style={{ fontFamily: 'JetBrains Mono, monospace', fontSize: 12, background: 'var(--bg-subtle)', padding: '12px 14px', borderRadius: 8, color: 'var(--text-secondary)', lineHeight: 1.7 }}>
              {`{\n  "tenant_id": 42,\n  "schema": "loja_exemplo_premium",\n  "action": "${log.action}",\n  "resource": "${log.resource}",\n  "result": "${log.result}",\n  "ip": "${log.ip}",\n  "ts": "${log.ts}"\n}`}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

// ── CockpitLogsTab ────────────────────────────────────────────────────────────
const CockpitLogsTab = ({ cockpitData, onToast }) => {
  const [search,   setSearch]   = React.useState('');
  const [actType,  setActType]  = React.useState('Todos');
  const [actorF,   setActorF]   = React.useState('Todos');
  const [severityF, setSeverityF] = React.useState('Todos');
  const [detail,   setDetail]   = React.useState(null);

  const logs = (cockpitData?.auditLog || COCKPIT_AUDIT_LOG).filter(l => {
    const q = search.toLowerCase();
    const matchSearch = !q || l.action.toLowerCase().includes(q) || l.actor.toLowerCase().includes(q) || l.resource.toLowerCase().includes(q);
    const matchType   = actType === 'Todos'    || l.action.includes(actType);
    const matchActor  = actorF  === 'Todos'    || l.actor === actorF;
    const matchSev    = severityF === 'Todos'  || l.severity === severityF;
    return matchSearch && matchType && matchActor && matchSev;
  });

  return (
    <div>
      <div className="card">
        {/* Toolbar */}
        <div className="table-toolbar" style={{ gap: 8, flexWrap: 'wrap' }}>
          <div className="search" style={{ maxWidth: 280 }}>
            <Icon name="search" size={14} />
            <input value={search} onChange={e => setSearch(e.target.value)} placeholder="Buscar nos logs…" />
          </div>
          <select className="select" value={actType} onChange={e => setActType(e.target.value)}>
            {ACTION_TYPES.map(t => <option key={t}>{t}</option>)}
          </select>
          <select className="select" value={actorF} onChange={e => setActorF(e.target.value)}>
            {ACTORS_LIST.map(a => <option key={a}>{a}</option>)}
          </select>
          <select className="select" value={severityF} onChange={e => setSeverityF(e.target.value)}>
            {SEVERITIES.map(s => <option key={s}>{s === 'Todos' ? 'Severidade' : SEVERITY_CFG[s]?.label || s}</option>)}
          </select>
          <div style={{ marginLeft: 'auto' }}>
            <button className="btn ghost sm" onClick={() => onToast('Log exportado como CSV')}>
              <Icon name="download" size={13} />Exportar
            </button>
          </div>
        </div>

        {/* Table */}
        {logs.length === 0 ? (
          <div style={{ padding: '40px 20px', textAlign: 'center', color: 'var(--text-muted)' }}>
            <Icon name="search" size={28} style={{ display: 'block', margin: '0 auto 10px' }} />
            <div style={{ fontSize: 14, fontWeight: 500 }}>Nenhum evento encontrado</div>
            <div style={{ fontSize: 12, marginTop: 4 }}>Tente ajustar os filtros ou o termo de busca</div>
          </div>
        ) : (
          <div style={{ overflowX: 'auto' }}>
            <table className="data" style={{ minWidth: 900 }}>
              <thead>
                <tr>
                  <th>Data/hora</th>
                  <th>Ator</th>
                  <th>Ação</th>
                  <th>Recurso</th>
                  <th>Resultado</th>
                  <th>IP</th>
                  <th>Severidade</th>
                  <th>Motivo</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {logs.map((log, i) => {
                  const sc  = SEVERITY_CFG[log.severity] || SEVERITY_CFG.info;
                  const rc  = RESULT_CFG[log.result]    || RESULT_CFG.success;
                  return (
                    <tr key={i}>
                      <td style={{ fontFamily: 'JetBrains Mono, monospace', fontSize: 12, color: 'var(--text-muted)', whiteSpace: 'nowrap' }}>{log.ts}</td>
                      <td>
                        <div style={{ fontSize: 13, fontWeight: 500 }}>{log.actor}</div>
                        <div style={{ fontSize: 11, color: 'var(--text-muted)' }}>{log.orgRole}</div>
                      </td>
                      <td style={{ fontSize: 13, maxWidth: 220 }}>{log.action}</td>
                      <td>
                        <span style={{ fontSize: 12, fontFamily: 'JetBrains Mono, monospace', color: 'var(--text-secondary)' }}>{log.resource}</span>
                      </td>
                      <td>
                        <span style={{ fontSize: 12, fontWeight: 600, color: rc.color }}>{rc.label}</span>
                      </td>
                      <td style={{ fontFamily: 'JetBrains Mono, monospace', fontSize: 11, color: 'var(--text-muted)' }}>{log.ip}</td>
                      <td>
                        <span style={{ fontSize: 10, fontWeight: 700, padding: '2px 7px', borderRadius: 4, background: sc.bg, color: sc.color, textTransform: 'uppercase', letterSpacing: '0.04em' }}>
                          {sc.label}
                        </span>
                      </td>
                      <td style={{ fontSize: 12, color: 'var(--text-muted)', maxWidth: 160, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                        {log.motivo}
                      </td>
                      <td>
                        <div className="row-actions">
                          <button className="icon-action" title="Ver detalhes" onClick={() => setDetail(log)}>
                            <Icon name="search" size={14} />
                          </button>
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}

        {/* Footer count */}
        <div style={{ padding: '10px 16px', borderTop: '1px solid var(--border)', fontSize: 12, color: 'var(--text-muted)', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <span>{logs.length} evento{logs.length !== 1 ? 's' : ''} encontrado{logs.length !== 1 ? 's' : ''}</span>
          <span>Retenção: 90 dias</span>
        </div>
      </div>

      <LogDetailDrawer log={detail} onClose={() => setDetail(null)} />
    </div>
  );
};

export {
  CockpitLogsTab,
};
